import request from './request';
import requestNew from "@/CommonDP/utils/request";
import qs from 'qs';
// import { from } from 'rxjs';

export default {
  getDutyList: (params) =>
    request(
      `/worktime/roleDicList?prjId=${params.prjId}&specId=${params.specId}&enterpriseId=${params.enterpriseId}`
    ).then((res) => res),
  getSpecList: (params) =>
    request(`/worktime/specDicList?prjId=${params.prjId}&enterpriseId=${params.enterpriseId}`).then((res) => res),
  queryUserNoSubmitDate: (params) =>
    request('/worktime/queryUserNoSubmitDate', {
      params
    }).then((res) => res),
  getOptions: (params) =>
    request('/worktime/dicList', {
      params
    }).then((res) => res),
  // 全部提交工时
  workTimeSubmit: (form) =>
    request
      .post(`/worktime/submit?${qs.stringify(form)}`)
      .then(({ data }) => data),
  // 批量删除工时
  workTimeBatchDelete: (form) =>
    request.post(`/worktime/batch-delete`, form).then((res) => res),
  workTimeWithdraw: (params) =>
    request.post(`/worktime/withdraw`, params).then((res) => res),
  // 新增工时填报
  workTimeAdd(form) {
    return request.post(`/worktime/add`, form).then((res) => res);
  },
  // 编辑工时填报
  workTimeUpdate(form) {
    return request.post(`/worktime/update`, form).then((res) => res);
  },

  // 获取新的项目列表
  getNewPrjList() {
    return request.get('/prj-home/get-all-prj/user').then((res) => res);
  },

  // startDate
  workTimeHomeList(params) {
    return request('/worktime/home-list', {
      params
    }).then((res) => res);
  },
  // 查当前用户参与得项目
  querydata(params) {
    return request.get('/project/list', params).then((res) => res);
  },
  queryPrjList() {
    // 查询全部项目
    return request.get('/project/list-all').then((res) => res);
  },
  ProjectUserList(params) {
    return request
      .get('/project/user-list', {
        params
      })
      .then((res) => res);
  },
  WorkTimeListPrj(pageNo, pageSize, params) {
    return request
      .get(`/worktime/list-prj?pageNo=${pageNo}&pageSize=${pageSize}`, params)
      .then((res) => res);
  },
  WorkTimeListUser(params) {
    return request
      .get('/worktime/list-user', {
        params
      })
      .then((res) => res);
  },
  WorktimeList(pageNo, pageSize, params) {
    return request
      .post(`/worktime/list?pageNo=${pageNo}&pageSize=${pageSize}`, params)
      .then((res) => res);
  },

  WorktimeDelete(id) {
    return request.post(`/worktime/delete/${id}`).then((res) => res);
  },
  addhoursReport(form) {
    return request.post('/worktime/add', form).then((res) => res);
  },
  WorktimeUpdate(form) {
    return request.post('/worktime/update', form).then((res) => res);
  },
  WorktimeResub(form) {
    return request.post('/worktime/resubmit', form).then((res) => res);
  },
  useradd(params) {
    return request
      .post('/user/add', qs.stringify(params))
      .then((res) => res.data);
  },
  WorktimeUpdateStatus(params) {
    return request.post('/worktime/update-status', params).then((res) => res);
  },
  WorktimeSub(params) {
    return request.post('/worktime/submit', params).then((res) => res);
  },
  WorktimeDetail(id) {
    return request.get('/worktime/detail?iD=' + id).then((res) => res);
  },
  WorktimeRecord(params) {
    console.log(params);
    return request.post('/worktime/record', params).then((res) => res);
  },

  // 已填报工时模块
  getProjectsData() {
    return request.get('/project/list').then((res) => res);
  },

  getDepartProjectsData() {
    return request.get('/project/approval-list').then((res) => res);
  },

  // getSubmittedHoursData(pageNo, pageSize, params) {
  //   return request.get(`/worktime/list?pageNo=${pageNo}& pageSize=${pageSize}`, params)
  //     .then(res => res)
  // },
  getHourDataById(id) {
    return request
      .get('/worktime/detail', {
        params: {
          iD: id
        }
      })
      .then((res) => res);
  },
  getApprovalRecordsData(id) {
    return request
      .get('/approvalhistory/list', {
        params: {
          iD: id
        }
      })
      .then((res) => res)
      .catch(function(reason) {
        console.log('catch:', reason);
      });
  },
  addRecallHour(recallForm) {
    return request
      .post('/worktime/update-status', recallForm)
      .then((res) => res);
  },
  // addResubmitHour(resubmitForm) {
  //   return request.post('/worktime/update', resubmitForm)
  //     .then(res => res.data)
  //     .catch(function (reason) {
  //       console.log('catch:', reason);
  //     })
  // },

  // 工时审批模块
  getProjectModeHoursData(pageNo, pageSize, params) {
    return request
      .post(`/worktime/list-prj?pageNo=${pageNo}&pageSize=${pageSize}`, params)
      .then((res) => res);
  },
  getPersonnelModeHoursData(pageNo, pageSize, params) {
    return request
      .post(`/worktime/list-user?pageNo=${pageNo}&pageSize=${pageSize}`, params)
      .then((res) => res);
  },
  getUsersData() {
    return request.get('/user/list').then((res) => res);
  },
  getPrjUsersData(queCategory) {
    return request
      .get('/user/project-list?queCategory=' + queCategory)
      .then((res) => res);
  },
  getPrjUsers(params) {
    return request.post('/user/list-staff', params).then((res) => res);
  },
  getPersonList(enterpriseId) {
    return request
      .get(`/count/personList?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },

  // 统计模块
  getStatisticalHoursData(params) {
    return request
      .post('/count/list', params)
      .then((res) => res)
      .catch(function(reason) {
        console.log('catch:', reason);
      });
  },
  // 统计模块新接口
  getStatisticalHoursDataNew(params, pageNo, pageSize) {
    return request
      .post(
        '/count/everybody/workTime?pageNo=' + pageNo + '&pageSize=' + pageSize,
        params
      )
      .then((res) => res);
  },
  getPrjWorkTimeData(params) {
    return request.post('/count/prjWorkTime', params)
      .then((res) => res)
      .catch(function(reason) {
        console.log('catch:', reason);
      });
  },
  getUserWorkTimeData(params) {
    return request.post('/count/personWorkTime', params)
      .then((res) => res)
      .catch(function(reason) {
        console.log('catch:', reason);
      });
  },
  getPrjUserData(params) {
    return request.post('/count/personCount', params)
      .then((res) => res)
      .catch(function(reason) {
        console.log('catch:', reason);
      });
  },
  countDetail(params) {
    return request
      .post('/worktime/currentUser/list', params)
      .then((res) => res);
  },
  exportExcel(params) {
    return request
      .get(
        `/worktime/export-excel?startDate=${params.startDate}&endDate=${params.endDate}`,
        params
      )
      .then((res) => res);
  },
  newExportExcel: (params) =>
    request('/worktime/export-excel', {
      responseType: 'stream',
      params
    }).then((res) => URL.createObjectURL(res)),

  queryTreeOrginfo() {
    return request
      .get(`/worktimeStatistics/newOrgInfo?type=children`)
      .then((res) => res);
  },
  //  我的审核  项目部分
  queryMyCheckPrj(pageNo, pageSize, params) {
    return request
      .post(
        `/worktime/role/list-prj?pageNo=${pageNo}&pageSize=${pageSize}`,
        params
      )
      .then((res) => res);
  },
  // 我的审核 人员部分
  queryMyCheckUser(pageNo, pageSize, params) {
    return request
      .post(
        `/worktime/role/list-user?pageNo=${pageNo}&pageSize=${pageSize}`,
        params
      )
      .then((res) => res);
  },
  overviewExcel(startDate, endDate, type, pageSize, pageNum, name, enterpriseId, prjIdList, deptIdList) {
    return requestNew({
      url: `/count/overview/excel?startDate=${startDate}&endDate=${endDate}&type=${type}&pageSize=${pageSize}
      &pageNum=${pageNum}&name=${name}&enterpriseId=${enterpriseId}&prjIdList=${prjIdList}&deptIdList=${deptIdList}`,
      method: "get",
      responseType: "blob"
    });
  }
};
